var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPdf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-3f157e76-925b-4e12-bcaf-73fd372d5fe2",
    "data-name": "Layer 2",
    viewBox: "0 0 27.26 31.91",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-83907922-7418-46fa-a44c-c52b484be5d1 {\n        fill: none;\n        stroke: #d4145a;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-61603ff9-7af5-4d3a-9734-ee24d61f9d6b",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-83907922-7418-46fa-a44c-c52b484be5d1",
    d: "m4.2,23.85c1.01-5.94,1.05-11.35.29-15.88-.13-.84.88-1.48,1.47-.93,3.47,3.1,7.83,5.43,13.36,6.17.89.12,1.04,1.34.18,1.65-5.76,2.07-9.73,4.74-13.6,9.51-.62.74-1.85.37-1.7-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-83907922-7418-46fa-a44c-c52b484be5d1",
    d: "m4.96,5.63l.02-2.79c.01-.9-.41-1.61-1.06-1.79h-.02c-.92-.25-2.01.61-2.41,1.89h0c-.31,1-.1,1.98.53,2.41l1.83,1.23c.45.3,1.11-.26,1.11-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-83907922-7418-46fa-a44c-c52b484be5d1",
    d: "m5.14,25.82l.22,2.76c.08.89-.39,1.72-1.18,2.11h-.02c-1.12.55-2.48.04-2.97-1.12h0c-.38-.9-.13-1.94.59-2.57l2.05-1.78c.5-.44,1.27-.08,1.32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-83907922-7418-46fa-a44c-c52b484be5d1",
    d: "m21.03,13.03l2.16-1.73c.69-.56,1.56-.67,2.21-.3h.02c.92.54,1.13,1.84.43,2.88h0c-.54.81-1.5,1.23-2.34,1.05l-2.39-.54c-.58-.13-.63-.93-.09-1.36Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pdf.d07ec96d.svg";
export { ForwardRef as ReactComponent };